module.exports = __webpack_public_path__ + "img/primary_10x2_z16.30e09abf.svg";